import { sortBlogs } from "./sortBlogs"; // Sorting function for blogs
import { Link } from "react-router-dom"; // react-router-dom Link for routing
import BlogCard from "./BlogCard";
import Heading from "../components/Heading";
import Section from "../components/Section";
// Reusable component for rendering each blog

const RecentPosts = ({ blogs }) => {
  const sortedBlogs = sortBlogs(blogs); // Sort blogs as per your logic

  return (
    <Section>
      <section className="sxl:px-32 container mt-16 flex w-full flex-col items-center justify-center px-5 pb-8 sm:px-10 md:mt-16 md:px-24">
        <Heading className="md:max-w-md lg:max-w-md" title="Blogs" />
        <div className="grid grid-cols-1 gap-16 sm:grid-cols-2 min-[1150px]:grid-cols-3">
          {sortedBlogs.slice(0, 6).map((blog, index) => (
            <BlogCard key={index} blog={blog} /> // Using the reusable component
          ))}
        </div>
        <Link
          to="/blog-categories/all" // Link to view all blogs
          className="text-accent dark:text-accentDark inline-block text-end text-base font-medium underline underline-offset-2 md:text-lg"
        >
          <h3 className="text-dark dark:text-light mt-12 inline-block w-fit text-center text-xl font-bold capitalize md:text-2xl">
            View All
          </h3>
        </Link>
      </section>
    </Section>
  );
};

export default RecentPosts;
